import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LogbookDialogComponent } from './logbook-dialog.component';
import { CustomMaterialModule } from '@sk/custom-material';
import { ReactiveFormsModule } from '@angular/forms';
import { TimefromnowPipeModule } from '../../../_shared/pipes/timefromnow-pipe/timefromnow-pipe.module';
import { ImageGalleryModule } from '../../../_shared/presentational-components/image-gallery/image-gallery.module';
import { WebImageGalleryModule } from '../../../_shared/presentational-components/web-image-gallery/web-image-gallery.module';
import { TimeFormatPwaModule } from '../../../_shared/pipes/timeFormatPwa/timeFormatPwa.module';


@NgModule({
  declarations: [
    LogbookDialogComponent
  ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ImageGalleryModule,
    WebImageGalleryModule,
    TimefromnowPipeModule,
    TimeFormatPwaModule
  ],
})
export class LogbookDialogModule {
}
